export const RewardPaymentOptions = {
  ApplyRewards: 1,
  DoNotApplyRewards: 2,
} as const satisfies Record<string, number>;
